export default __webpack_public_path__ + "media/zurb/img/development-process/accessibility-3f731c5fa844232822c3b67f2456334e.png";